// Contact page Indonesian translations

export default {
  pageTitle: "Formulir Inkuiri",
  breadcrumbHome: "Beranda",
  breadcrumbContact: "Formulir Inkuiri",
  title: "Formulir Inkuiri",
  address: "Alamat",
  addressDetails: "EJIP Industrial Park, Plot 8G, Sukaresmi, Cikarang Sel., Kabupaten Bekasi, Jawa Barat 17550",
  callUs: "Hubungi Kami",
  phoneNumber: "(021) 8970178",
  emailUs: "Email Kami",
  emailAddress: "sales@ekkeagle.co.id",
  yourName: "Nama Anda",
  yourEmail: "Email Anda",
  subject: "Subjek",
  message: "Pesan",
  sending: "Mengirim...",
  sendMessage: "Kirim Pesan",
  loading: "Memuat",
  successMessage: "Pesan Anda telah disimpan dan email terkirim (email konfirmasi dikirim ke pengguna). Terima kasih!",
  errorMessage: "Gagal mengirim pesan",
  errorSending: "Kesalahan mengirim pesan. Silakan coba lagi.",
  successAlert: "Berhasil! Inkuiri Anda telah berhasil dikirim.",
  errorAlert: "Kesalahan: "
};